export const SideNavs = {
  items: [
    {
      name: "لوحة التحكم",
      url: "/MyTicket/Dashboard",
      icon: "fa fa-tachometer-alt",
      roleNumber: -1,
    },
    {
      name: "الصفحة الشخصية",
      url: "/MyTicket/profile",
      icon: "fas fa-user-cog",
      roleNumber: -1,
    },
    {
      name: "عن التطبيق",
      url: "/MyTicket/AboutApp",
      icon: "fas fa-cogs",
      roleNumber: 6,
    },
    {
      name: "مركز المساعدة",
      icon: "fas fa-cogs",
      roleNumber: 30,
      childrens: [
        {
          name: "من نحن",
          url: "/MyTicket/AboutUs",
          roleNumber: 30,
        },
        {
          name: "خطوات الحجز",
          url: "/MyTicket/ReservationSteps",
          roleNumber: 30,
        },
      ],
    },
    {
      name: "المناطق",
      icon: "fa fa-film",
      childrens: [
        {
          name: "البلاد",
          url: "/MyTicket/ViewCountry",
          roleNumber: 18,
        },
        {
          name: "المدن",
          url: "/MyTicket/ViewCity",
          roleNumber: 18,
        },
        {
          name: "الاحياء",
          url: "My-Ticket/ViewRegion",
          roleNumber: 18,
        },
      ],
    },
    {
      name: "الصور المتحركة",
      url: "/MyTicket/sliders",
      icon: "fas fa-image",
      roleNumber: 2,
    },
    {
      name: "فيديو الرئيسيه",
      url: `/MyTicket/AppSetting/Advirtisments`,
      icon: "fas fa-flag",
      roleNumber: 16,
    },

    {
      name: "داعمي المواهب بالمملكه",
      url: "/MyTicket/sponser",
      icon: "fas fa-hands-helping",
      roleNumber: 17,
    },
    {
      name: "المسؤولين",
      url: "/MyTicket/subAdmin",
      icon: "fa fa-user-tie",
      roleNumber: 3,
    },

    {
      name: "العملاء",
      url: "/MyTicket/clients",
      icon: "fa fa-users",
      roleNumber: 1,
    },
    {
      name: "المواهب",
      icon: "fa fa-gift",
      childrens: [
        {
          name: "الاقسام",
          url: "/MyTicket/Talent-Section",
          roleNumber: 19,
        },
        {
          name: "انواع المواهب",
          url: "/MyTicket/Talent-type",
          roleNumber: 19,
        },
        {
          name: "المواهب",
          url: "/MyTicket/Talents",
          roleNumber: 19,
        },
        {
          name:' الطلبات علي الموهوبين',
          url:"/MyTicket/ViewTalentOrder",
          roleNumber: 19,
        },
       
      ],
    },

    {
      name: "المنشأت",
      url: "/MyTicket/Corporation",
      icon: "fa fa-building",
      roleNumber: 20,
    },
    {
      name: "الفئات",
      url: "/MyTicket/category",
      icon: "fa fa-sitemap",
      roleNumber: 8,
    },
    {
      name: "مُنظمين الفاعليات",
      url: "/MyTicket/Events",
      icon: "far fa-calendar-alt",
      badge: true,
      id: 0,
      roleNumber: 4,
    },

    {
      name: " السينمات",
      url: "/MyTicket/cinemas",
      icon: "fas fa-film",
      badge: true,
      id: 0,
      roleNumber: 5,
    },
    {
      name: "الكاشير",
      url: "/MyTicket/ViewCashier",
      icon: "fas fa-user-tag",
      badge: true,
      id: 0,
      roleNumber: 21,
    },
    {
      name: "انواع التذاكر",
      url: "/MyTicket/ViewTicketPrice",
      icon: "fas fa-ticket-alt",
      badge: true,
      id: 0,
      roleNumber: 22,
    },
    {
      name: "القاعات",
      url: "/MyTicket/ViewHalls",
      icon: "fas fa-building",
      badge: true,
      id: 0,
      roleNumber: 23,
    },
    {
      name: "الافلام",
      url: "/MyTicket/films",
      icon: "fa fa-film",
      childrens: [
        {
          name: "أنواع أفلام",
          url: "/MyTicket/filmTypes",
          roleNumber: 6,
        },
        {
          name: "الافلام",
          url: "/MyTicket/films",
          roleNumber: 7,
        },
      ],
    },
    {
      name: "العروض",
      icon: "fas fa-images",
      childrens: [
      
        {
          name: "عروض السنيما",
          url: "/MyTicket/cinemaShows-admin",
          roleNumber: 11,
        },
        {
          name: "عروض الفاعليات",
          url: "/MyTicket/eventShows-admin",
          roleNumber: 12,
        },
        {
          name: "العروض بتذاكر",
          url: "/MyTicket/ViewOurShows",
          roleNumber: 25,
        },
        {
          name: "الانشطة المجانية",
          url: "/MyTicket/ViewOurFreeShows",
          roleNumber: 24,
        },
      ],
    },

    {
      name: "الحجوزات",
      icon: "fas fa-ticket-alt",
      childrens: [
        {
          name: "حجوزات الفاعليات",
          url: "/MyTicket/ViewReservation-Event-admin",
          roleNumber: 14,
        },
        {
          name: "حجوزات السينما",
          url: "/MyTicket/ViewReservation-cinema-admin",
          roleNumber: 13,
        },
        {
          name: "حجوزات المجانية",
          url: "/MyTicket/ViewFreeReservation",
          roleNumber: 26,
        },
        {
          name: "عروض بتذاكر",
          url: "/MyTicket/ViewTicketReservation",
          roleNumber: 27,
        },
        
      ],
    },
    {
      name: "المعالم السياحية",
      url: "/MyTicket/TOURISTICAL_MONUMENTS",
      icon: "fas fa-route",
      roleNumber: 28,
    },
    {
      name: "الانشطة الترفيهية",
      url: "/MyTicket/ViewEntertainement",
      icon: "fas fa-mountain",
      roleNumber: 29,
    },
    {
      name: "الاشعارات",
      url: "/MyTicket/notification",
      icon: "fas fa-exclamation-triangle",
      roleNumber: 15,
    },
    {
      name: "كود الخصم",
      url: "/MyTicket/promoCode",
      icon: "fas fa-percent",
      roleNumber: 15,
    },
    {
      name: "تواصل معنا",
      url: `/MyTicket/PreviewChat`,
      icon: "fa fa-comments",
      id: 0,
      roleNumber: 31,
    },
    {
      name: "التقارير",
      url: "/MyTicket/ReportFilteration",
      icon: "fa fa-file",
      roleNumber: 9,
    },
  ],
};

export const SideNavsEn = {
  items: [
    {
      name: "DashBoard",
      url: "/MyTicket/Dashboard",
      icon: "fa fa-tachometer-alt",
      roleNumber: -1,
    },
    {
      name: "Admin Profile",
      url: "/MyTicket/profile",
      icon: "fas fa-user-cog",
      roleNumber: -1,
    },
    {
      name: "About App",
      url: "/MyTicket/AboutApp",
      icon: "fas fa-cogs",
      roleNumber: 6,
    },
    {
      name: "Help Center",
      icon: "fas fa-cogs",
      roleNumber: 30,
      childrens: [
      
        {
          name: "About Us",
          url: "/MyTicket/AboutUs",
          roleNumber: 30,
        },
        {
          name: "Reservation Steps",
          url: "/MyTicket/ReservationSteps",
          roleNumber: 30,
        },
      ],
    },
    {
      name: "Area",
      icon: "fa fa-film",
      childrens: [
        {
          name: "Countries",
          url: "/MyTicket/ViewCountry",
          roleNumber: 18,
        },
        {
          name: "Cities",
          url: "/MyTicket/ViewCity",
          roleNumber: 18,
        },
        {
          name: "Regions",
          url: "/MyTicket/ViewRegion",
          roleNumber: 18,
        },
      ],
    },
    {
      name: "Slider",
      url: "/MyTicket/sliders",
      icon: "fas fa-image",
      roleNumber: 2,
    },
    {
      name: "Home Video",
      url: `/MyTicket/AppSetting/Advirtisments`,
      icon: "fas fa-flag",
      roleNumber: 16,
    },

    {
      name: "Supporters of talent",
      url: "/MyTicket/sponser",
      icon: "fas fa-hands-helping",
      roleNumber: 17,
    },
    {
      name: "Sub-Admins",
      url: "/MyTicket/subAdmin",
      icon: "fa fa-user-tie",
      roleNumber: 3,
    },

    {
      name: "Clients",
      url: "/MyTicket/clients",
      icon: "fa fa-users",
      roleNumber: 1,
    },
    {
      name: "Talent",
      icon: "fa fa-gift",
      childrens: [
        {
          name: "Sections",
          url: "/MyTicket/Talent-Section",
          roleNumber: 19,
        },
        {
          name: "Talent Type",
          url: "/MyTicket/Talent-type",
          roleNumber: 19,
        },
        {
          name: "Talent",
          url: "/MyTicket/Talents",
          roleNumber: 19,
        },
        {
          name:"Talents's Orders",
          url:"/MyTicket/ViewTalentOrder",
          roleNumber: 19,
        },
       
      ],
    },

    {
      name: "Corporation",
      url: "/MyTicket/Corporation",
      icon: "fa fa-building",
      roleNumber: 20,
    },
    {
      name: "Category",
      url: "/MyTicket/category",
      icon: "fa fa-sitemap",
      roleNumber: 8,
    },
    {
      name: "Event Organizers",
      url: "/MyTicket/Events",
      icon: "far fa-calendar-alt",
      badge: true,
      id: 0,
      roleNumber: 4,
    },
    {
      name: "Cinema",
      url: "/MyTicket/cinemas",
      icon: "fas fa-film",
      badge: true,
      id: 0,
      roleNumber: 5,
    },
    {
      name: "Cashier",
      url: "/MyTicket/ViewCashier",
      icon: "fas fa-user-tag",
      badge: true,
      id: 0,
      roleNumber: 21,
    },
    {
      name: "Tickets type ",
      url: "/MyTicket/ViewTicketPrice",
      icon: "fas fa-ticket-alt",
      badge: true,
      id: 0,
      roleNumber: 22,
    },
    {
      name: "Halls",
      url: "/MyTicket/ViewHalls",
      icon: "fas fa-building",
      badge: true,
      id: 0,
      roleNumber: 23,
    },
    {
      name: "Films",
      url: "/MyTicket/films",
      icon: "fa fa-film",
      childrens: [
        {
          name: "Film Types",
          url: "/MyTicket/filmTypes",
          roleNumber: 6,
        },
        {
          name: "Films",
          url: "/MyTicket/films",
          roleNumber: 7,
        },
      ],
    },
    {
      name: "Shows",
      icon: "fas fa-images",
      childrens: [
       
        {
          name: "Cinema Shows",
          url: "/MyTicket/cinemaShows-admin",
          roleNumber: 11,
        },
        {
          name: "Event Shows",
          url: "/MyTicket/eventShows-admin",
          roleNumber: 12,
        },
        {
          name: "Show via Ticket",
          url: "/MyTicket/ViewOurShows",
          roleNumber: 25,
        },
        {
          name: "Free Show",
          url: "/MyTicket/ViewOurFreeShows",
          roleNumber: 24,
        },
      ],
    },

    {
      name: "Reservation",
      icon: "fas fa-ticket-alt",
      childrens: [
        {
          name: "Event Reservation",
          url: "/MyTicket/ViewReservation-Event-admin",
          roleNumber: 14,
        },
        {
          name: "Cinema Reservation",
          url: "/MyTicket/ViewReservation-cinema-admin",
          roleNumber: 13,
        },
        {
          name: "Free Reservations",
          url: "/MyTicket/ViewFreeReservation",
          roleNumber: 26,
        },
        {
          name: "Reservations Via Tickets",
          url: "/MyTicket/ViewTicketReservation",
          roleNumber:27,
        },
        
      ],
    },
    {
      name: "Tourist Places",
      url: "/MyTicket/TOURISTICAL_MONUMENTS",
      icon: "fas fa-route",
      roleNumber: 28,
    },
    {
      name: "Entertainement Activities",
      url: "/MyTicket/ViewEntertainement",
      icon: "fas fa-mountain",
      roleNumber: 29,
    },
    {
      name: "Notification",
      url: "/MyTicket/notification",
      icon: "fas fa-exclamation-triangle",
      roleNumber: 15,
    },
    {
      name: "PromoCode",
      url: "/MyTicket/promoCode",
      icon: "fas fa-percent",
      roleNumber: 15,
    },
    {
      name: "Contact Us",
      url: `/MyTicket/PreviewChat`,
      icon: "fa fa-comments",
      id: 0,
      roleNumber: 31,
    },
    {
      name: "Reports",
      url: "/MyTicket/ReportFilteration",
      icon: "fa fa-file",
      roleNumber: 9,
    },
  ],
};
